export enum MarketAreaStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "DISABLED",
}

export enum MarketAreaType {
  POLYGON = "POLYGON",
  RADIUS = "RADIUS",
}

export enum MarketAreaAnalysisStatus {
  NOT_ANALYZED = "NOT_ANALYZED",
  IN_PROGRESS = "IN_PROGRESS",
  ANALYZED = "ANALYZED",
  FAILED = "FAILED",
}

export interface IMarketAreaVertex {
  latitude: number;
  longitude: number;
}

export interface IMarketAreaGeometry {
  type: string;
  vertices: IMarketAreaVertex[];
}

export interface IMarketArea {
  id: string;
  name: string;
  description: string | null;
  type: MarketAreaType;
  geometry: IMarketAreaGeometry;
  analysisStatus: MarketAreaAnalysisStatus;
  status: MarketAreaStatus;
  createdBy: string;
  creationDate: string;
  lastAnalysisDate: string | null;
}

export interface IMarketAreasInfo {
  totalCount: number;
  activeCount: number;
  objects: IMarketArea[];
}
